interface GraphArrowUpInsideCircleSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GraphArrowUpInsideCircleSVG = ({
  color,
  style,
}: GraphArrowUpInsideCircleSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="39"
    height="50"
    viewBox="0 0 39 50"
    fill="none"
  >
    <g clipPath="url(#clip0_683_8237)">
      <path
        d="M37.0845 49.3353H1.7569L5.08073 39.5537H33.7488L37.0845 49.3353Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19.4207 4.08384V0.665039"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1292 5.33028L11.9539 2.11328"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.64484 8.64186L5.44873 6.03027"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.6206 13.6401L0.664764 11.9307"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7004 5.33028L26.8756 2.11328"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.1966 8.64186L33.3927 6.03027"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.2089 13.6401L38.1648 11.9307"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.41643 39.5538C6.56458 36.8947 3.03894 32.9773 3.03894 26.2822C3.03894 17.2366 10.3751 9.90039 19.4207 9.90039C28.4663 9.90039 35.8025 17.2366 35.8025 26.2822C35.8025 30.8524 33.2502 36.3012 30.235 39.2689"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.0166 29.0361H13.0935C12.7789 29.0361 12.5237 29.2912 12.5237 29.6059V34.1525C12.5237 34.4672 12.7789 34.7223 13.0935 34.7223H15.0166C15.3313 34.7223 15.5864 34.4672 15.5864 34.1525V29.6059C15.5864 29.2912 15.3313 29.0361 15.0166 29.0361Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.3941 27.0186H18.471C18.1564 27.0186 17.9012 27.2737 17.9012 27.5884V34.1411C17.9012 34.4558 18.1564 34.7109 18.471 34.7109H20.3941C20.7088 34.7109 20.9639 34.4558 20.9639 34.1411V27.5884C20.9639 27.2737 20.7088 27.0186 20.3941 27.0186Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M25.736 24.5137H23.8129C23.4982 24.5137 23.2431 24.7688 23.2431 25.0835V34.1409C23.2431 34.4556 23.4982 34.7107 23.8129 34.7107H25.736C26.0507 34.7107 26.3058 34.4556 26.3058 34.1409V25.0835C26.3058 24.7688 26.0507 24.5137 25.736 24.5137Z"
        stroke={color}
        strokeWidth="1.12"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M10.3989 34.7227H28.2051"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0608 25.0835C17.2484 24.5849 21.0589 23.0417 22.9938 21.3679C24.9169 19.6823 25.2374 17.8542 25.5342 16.0498C25.5342 16.0498 24.727 16.9876 22.7802 17.3675"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5223 16.0498C25.5223 16.0498 26.6619 17.8542 27.5285 18.602"
        stroke={color}
        strokeWidth="1.12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_683_8237">
        <rect width="38.8295" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GraphArrowUpInsideCircleSVG;
